module.exports = "query PaginatedBanners (\n  $page: Int = 1\n  $tag: String\n  $type: String\n  $quantity: Int!\n)\n{\n  paginatedBanners (\n    page:      $page,\n    tag:       $tag,\n    type:      $type\n    limit:     $quantity\n  )\n  {\n    data {\n      image\n      link\n      type\n      name\n      institutional\n      showcase\n      id\n      partner { slug }\n      campaign { slug }\n    }\n    quantity: total\n    page: current_page\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/queries/PaginatedBanners.graphql
// module id = 1862
// module chunks = 1610